import { RuleCard, type RuleCardProps } from '../RuleCard';
import { useRuleList } from './RuleListProvider';

export interface RuleListItemProps
  extends Pick<
    RuleCardProps,
    | 'header'
    | 'content'
    | 'disabled'
    | 'action'
    | 'expandable'
    | 'selected'
    | 'onClick'
    | 'onMouseEnter'
    | 'onMouseLeave'
    | 'iconRight'
  > {
  id: string;
  'aria-label'?: string;
  withBackground?: boolean;
  headerSelected?: boolean;
}

export const RuleListItem = ({
  id,
  header,
  content,
  action,
  disabled,
  expandable,
  selected,
  onClick,
  onMouseEnter,
  onMouseLeave,
  iconRight,
  headerSelected,
  withBackground = true,
  'aria-label': ariaLabel,
}: RuleListItemProps) => {
  const { isRuleItemOpen, onOpenRule, onCloseRule } = useRuleList();

  return (
    <RuleCard
      withBackground={withBackground}
      open={isRuleItemOpen(id)}
      onOpenChange={(isOpen) => (isOpen ? onOpenRule(id) : onCloseRule(id))}
      header={header}
      content={content}
      action={action}
      disabled={disabled}
      expandable={expandable}
      selected={selected}
      onClick={onClick}
      headerSelected={headerSelected}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      iconRight={iconRight}
      aria-label={ariaLabel}
    />
  );
};
